import FailedReportList from "./component";
import FailedReportListContainer from "./container";

export { FailedReportList, FailedReportListContainer };
export default FailedReportListContainer;



// WEBPACK FOOTER //
// ./client/modules/Admin/components/FailedReportList/index.ts